/* eslint-disable react/display-name */
import React, { useState, useEffect ,useRef} from 'react'
import { useQuery, gql, useApolloClient, useLazyQuery } from '@apollo/client'
import { withTranslation } from 'react-i18next'
import CustomLoader from '../components/Loader/CustomLoader'
// core components
import Header from '../components/Headers/Header'
import { getallorder, getorderFilter,searchOrdersByIdNamePhone } from '../apollo'
import DataTable from 'react-data-table-component'
import orderBy from 'lodash/orderBy'
import { Container, Button, useTheme, Typography, Box, Badge, FormControl, InputLabel ,MenuItem ,Select } from '@mui/material'
import { customStyles } from '../utils/tableStyleFOrAllOrders'
import useGlobalStyles from '../utils/globalStyles'
import TableHeader from '../components/TableHeader'
import { useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom';
import TuneIcon from '@mui/icons-material/Tune';
import AllOrderFilter from '../utils/fIlters/AllOrderFilter'
import { makeStyles } from '@material-ui/core/styles'; // <-- Ensure this import
import SearchBar from '../components/TableHeader/SearchBar'
const LAST_ORDER_LIST_PAGE = 'lastOrderListPage';
const LAST_ORDER_LIST_SCROLL_POS = 'lastOrderListScrollPos';
const LAST_ORDER_LIST_PER_PAGE = 'lastOrderListPerPage';
const IS_BACK_FROM_ORDER_DETAILS = 'isBackFromOrderDetails';
const LAST_SELECTED_ORDER_ID = 'lastSelectedOrderId';

const SEARCH_ORDERS=gql`
${searchOrdersByIdNamePhone}`

const GET_ALL_ORDER = gql`
  ${getallorder}
`
const GET_ALL_ORDER_filter = gql`
  ${getorderFilter}
`

const formatOrderDate = (value) => {
  if (!value) return 'NA'

  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value

  return new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Asia/Kolkata',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  }).format(date)
}

const Restaurants = props => {
  const { t } = props;
  const history = useHistory();
  const theme = useTheme();
  const client = useApolloClient();
  const globalClasses = useGlobalStyles()
  const userType = JSON.parse(localStorage.getItem('user-native')).userType
  const [page, setPage] = useState(
    1
  );
  var [tableData, setTableData] = useState([])
  const [currentPage, setCurrentPage] = useState(page);
  const [totalRows, setTotalRows] = useState(0)
  const [perPage, setPerPage] = useState(10)
  var [FilterPaload, setFilterPaload] = useState({})
  var [DefaultValue, setDefaultValue] = useState({})
  const [badgeContent, setbadgeContent] = useState(false);
  const [reload, setReload] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')
  var dataSearchReset = undefined
  const [searchField, setSearchField] = useState(null)
  const tableRef = useRef(null);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [readyToQuery, setReadyToQuery] = useState(false); // Delay query execution until state is restored

useEffect(() => {
  const storedPage = localStorage.getItem(LAST_ORDER_LIST_PAGE);
  const storedScrollPos = localStorage.getItem(LAST_ORDER_LIST_SCROLL_POS);
  const storedPerPage = localStorage.getItem(LAST_ORDER_LIST_PER_PAGE);
  const storedSelectedId = localStorage.getItem(LAST_SELECTED_ORDER_ID);
  const storedFilterPayload = localStorage.getItem('lastOrderFilterPayload');
  const storedFilterDefaults = localStorage.getItem('lastOrderFilterDefaults');
  const isFilterApplied = localStorage.getItem('isOrderFilterApplied') === 'true';
  const searchActive = localStorage.getItem('isOrderSearchActive') === 'true';
  const lastSearchQuery = localStorage.getItem('lastOrderSearchQuery');
  const backNavigated = localStorage.getItem(IS_BACK_FROM_ORDER_DETAILS) === 'true';
  const lastSearchField = localStorage.getItem('lastOrderSearchField');
  const navigatedFromOrderDetails =
    history.action === 'POP' &&
    history.location &&
    history.location.state &&
    history.location.state.fromOrderDetails;

  if (backNavigated && storedPage) {
    const parsedPage = parseInt(storedPage, 10);
    setPage(parsedPage);
    setCurrentPage(parsedPage);

    if (storedPerPage) {
      setPerPage(parseInt(storedPerPage, 10));
    }

    if (storedScrollPos && tableRef.current) {
      setTimeout(() => {
        tableRef.current.parentElement.parentElement.scrollTo(0, parseInt(storedScrollPos, 10));
      }, 100);
    }

    if (storedSelectedId) {
      setSelectedOrderId(storedSelectedId)
    }

    if (isFilterApplied && storedFilterPayload) {
      const parsedPayload = JSON.parse(storedFilterPayload);
      const parsedDefaults = JSON.parse(storedFilterDefaults);

      setFilterPaload(parsedPayload);
      setDefaultValue(parsedDefaults);
      setbadgeContent(true); // triggers useEffect to call refetchFilterData
    }

    if (searchActive && lastSearchQuery) {
  setSearchQuery(lastSearchQuery);
  if (lastSearchField) setSearchField(lastSearchField); // <-- ADD THIS

  setTimeout(() => {
    refetchSearch({
      variables: {
        orderId: lastSearchField === "orderId" ? lastSearchQuery : "",
        name: lastSearchField === "name" ? lastSearchQuery : "",
        phone: lastSearchField === "phone" ? lastSearchQuery : "",
        limit: parseInt(storedPerPage, 10),
        skip: (parsedPage - 1) * parseInt(storedPerPage, 10),
      },
    });
  }, 100);
}

    // Cleanup
    localStorage.removeItem(IS_BACK_FROM_ORDER_DETAILS);
    localStorage.removeItem(LAST_ORDER_LIST_PAGE);
    localStorage.removeItem(LAST_ORDER_LIST_SCROLL_POS);
    localStorage.removeItem(LAST_ORDER_LIST_PER_PAGE);
    localStorage.removeItem(LAST_SELECTED_ORDER_ID);
    localStorage.removeItem('lastOrderFilterPayload');
    localStorage.removeItem('lastOrderFilterDefaults');
    localStorage.removeItem('isOrderFilterApplied');
    localStorage.removeItem('lastOrderSearchQuery');
    localStorage.removeItem('isOrderSearchActive');
    localStorage.removeItem('lastOrderSearchField');

  } else if (!navigatedFromOrderDetails) {
    // Fresh load - clear all
    setPage(1);
    setCurrentPage(1);

    localStorage.removeItem(LAST_ORDER_LIST_PAGE);
    localStorage.removeItem(LAST_ORDER_LIST_SCROLL_POS);
    localStorage.removeItem(IS_BACK_FROM_ORDER_DETAILS);
    localStorage.removeItem(LAST_ORDER_LIST_PER_PAGE);
    localStorage.removeItem(LAST_SELECTED_ORDER_ID);
    localStorage.removeItem('lastOrderFilterPayload');
    localStorage.removeItem('lastOrderFilterDefaults');
    localStorage.removeItem('isOrderFilterApplied');
    localStorage.removeItem('lastOrderSearchQuery');
    localStorage.removeItem('isOrderSearchActive');
    localStorage.removeItem('lastOrderSearchField');

  }

  setReadyToQuery(true); // Allow table to load
}, [history.action, history.location.state]);

  const cleanPayload = (obj) => {
    return Object.fromEntries(
      Object.entries(obj)
        .filter(([key, value]) => value !== "" && value !== null)
    );
  };

  const [refetchfilterData] = useLazyQuery(GET_ALL_ORDER_filter, {
    fetchPolicy: 'no-cache',
    onCompleted: (resultData) => {
      console.log("refetchfilterData onCompleted - Result:", resultData); // LOG 3
      if (resultData && resultData.getAllOrdersByFilter) {
        const filteredOrders = resultData.getAllOrdersByFilter.orders || [];
        console.log('Filtered Orders (onCompleted):', filteredOrders); // LOG 4
        setTableData(filteredOrders); // <--- THIS LINE IS CRUCIAL
        setTotalRows(resultData.getAllOrdersByFilter.totalCount || 0);
        CloseFilter();
      }
    },
    onError: error => {
      const isForbiddenError = error && error.graphQLErrors.some(err => err.extensions.code === 'FORBIDDEN');
      if (isForbiddenError) {
        localStorage.removeItem('user-native');
        localStorage.removeItem('restaurant_id');
        client.clearStore();
        props.history.push('/auth/login');
      }
    },
  });

  const variablesSearch = {
    orderId: searchField === "orderId" ? searchQuery : "",
    name: searchField === "name" ? searchQuery : "",
    phone: searchField === "phone" ? searchQuery : "",
    limit: perPage,
    skip: (page - 1) * perPage,
  };
  const { data, loading: loadingQuery, refetch } = useQuery(GET_ALL_ORDER, {
    skip: !readyToQuery,
    fetchPolicy: "no-cache",
    variables: {
      limit: perPage,
      skip: (page - 1) * perPage,
    },
    onCompleted: (data) => {
      if (!searchQuery && !badgeContent) { // <--- CHECK THIS CONDITION
        
        const orders = (data && data.getAllOrders && data.getAllOrders.orders) ? data.getAllOrders.orders : [];
        
        setTableData(orders);
        setTotalRows(data && data.getAllOrders ? data.getAllOrders.totalCount : 0);
      }
    },
    onError: error => {
      const isForbiddenError = error && error.graphQLErrors.some(err => err.extensions.code === 'FORBIDDEN');
      if (isForbiddenError) {
        localStorage.removeItem('user-native');
        localStorage.removeItem('restaurant_id');
        client.clearStore();
        props.history.push('/auth/login');
      }
    },
  });
  const { loading: searchLoading, error: searchError, data: searchData, refetch: refetchSearch } = useQuery(SEARCH_ORDERS, {
    variables: variablesSearch,
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      console.log("Search Query Completed:", variablesSearch, data);
     console.log("Search Data:", data);
      if (searchQuery && data && data.searchOrdersByIdNamePhone) {
        const orders = data.searchOrdersByIdNamePhone.orders || [];
        console.log('Orders (Search) BEFORE setting tableData:', orders);
        setTableData(orders);
        console.log('tableData AFTER setting:', tableData); // Add this log
        setTotalRows(data.searchOrdersByIdNamePhone.totalCount || 0);
      }
    },
    onError: (error) => {
      const isForbiddenError = error && error.graphQLErrors && error.graphQLErrors.some(err => err.extensions.code === 'FORBIDDEN');
      if (isForbiddenError) {
        localStorage.removeItem('user-native');
        localStorage.removeItem('restaurant_id');
        client.clearStore();
        props.history.push('/auth/login');
      }
    },
  });
 console.log(" FULL ORDER DATA:", data); // or `data`
  useEffect(() => {
    console.log("tableData state changed:", tableData);
  }, [tableData]);
  useEffect(() => {
    console.log("useEffect triggered - page:", page, "searchQuery:", searchQuery);
    if (searchQuery) {
      refetchSearch({
        variables: {
          orderId: searchField === "orderId" ? searchQuery : "",
          name: searchField === "name" ? searchQuery : "",
          phone: searchField === "phone" ? searchQuery : "",
          limit: perPage,
          skip: (page - 1) * perPage,
        },
      });
    }
  }, [page, searchQuery, searchField, perPage, refetchSearch]);
  useEffect(() => {
    console.log("useEffect (filter) triggered - page:", page, "badgeContent:", badgeContent, "DefaultValue:", DefaultValue);
    if (badgeContent === true) {
     console.log("Refetching filtered data with:", {
      filterInput: cleanPayload(DefaultValue),
      limit: perPage,
      skip: (page - 1) * perPage,
     });
     refetchfilterData({
      variables: {
       filterInput: cleanPayload(DefaultValue),
       limit: perPage,
       skip: (page - 1) * perPage,
      },
     });
    }
   }, [page, perPage, refetchfilterData, badgeContent, DefaultValue]);

  /*useEffect(() => {
    if (data && data.getAllOrders && data.getAllOrders.orders && dataSearchReset === undefined) {
      if (!searchQuery) {
        setTableData(data.getAllOrders.orders || []); // Added fallback to empty array
        setTotalRows(data.getAllOrders.totalCount || 0); // Added fallback to 0
      }
    } else if (searchData && searchData.searchOrdersByIdNamePhone && searchData.searchOrdersByIdNamePhone.orders) {
      setTableData(searchData.searchOrdersByIdNamePhone.orders || []);
      setTotalRows(searchData.searchOrdersByIdNamePhone.totalCount || 0);
    }
  }, [data, searchData, reload, searchQuery, dataSearchReset]);*/
 
  
  useEffect(() => {
    if (data && !searchQuery && !badgeContent) {
      setTotalRows(data.getAllOrders.totalCount);
      setTableData(data.getAllOrders.orders);
    }
  }, [data, reload, searchQuery, badgeContent]);
 
  
  useEffect(() => {
    if (badgeContent === true) {
      console.log("useEffect (badgeContent true) - page:", page, "DefaultValue:", DefaultValue);
      refetchfilterData({
        variables: {
          filterInput: cleanPayload(DefaultValue),
          limit: perPage,
          skip: (page - 1) * perPage,
        },
      });
    } else if (searchQuery) {
      console.log("useEffect (searchQuery true) - page:", page, "searchQuery:", searchQuery);
      const variablesSearch = {
        orderId: searchField === "orderId" ? searchQuery : "",
        name: searchField === "name" ? searchQuery : "",
        phone: searchField === "phone" ? searchQuery : "",
        limit: perPage,
        skip: (page - 1) * perPage,
      };
      refetchSearch({ variables: variablesSearch });
    } else {
      console.log("useEffect (no search or filter) - page:", page);
      refetch({
        variables: {
          limit: perPage,
          skip: (page - 1) * perPage,
        },
      });
    }
  }, [page, perPage, refetch, refetchfilterData, refetchSearch, badgeContent, searchQuery, searchField, DefaultValue]);
    const handleSearchFieldChange = (event) => {
      setSearchField(event.target.value);
      setSearchQuery(''); // Optionally clear the search query when the field changes
    };
  
    const handleSearch = (value) => {
      setSearchQuery(value);
      setPage(1);
      refetchSearch({ variables: variablesSearch });
    };
  const handlePerRowChange = (newPerPage) => {
    setPerPage(newPerPage);
    setPage(1); // Reset to first page when perPage changes
  };
  // Inside your handlePageChange function, update the local storage
  const handlePageChange = (newPage) => {
    console.log("handlePageChange CALLED - newPage:", newPage, "badgeContent:", badgeContent);
    setPage(newPage);
    setCurrentPage(newPage);
  
    if (searchQuery) {
      refetchSearch({
        variables: {
          orderId: searchField === "orderId" ? searchQuery : "",
          name: searchField === "name" ? searchQuery : "",
          phone: searchField === "phone" ? searchQuery : "",
          limit: perPage,
          skip: (newPage - 1) * perPage,
        },
      });
    } else if (badgeContent) {
      console.log("FILTERED DATA PATH"); // Add this log
      console.log("DefaultValue:", DefaultValue); // Add this log
      const variables = {
        filterInput: cleanPayload(DefaultValue),
        limit: perPage,
        skip: (newPage - 1) * perPage,
      };
      console.log("refetchfilterData VARIABLES:", variables); // Add this log
      refetchfilterData({ variables });
    } else {
      refetch({
        variables: {
          limit: perPage,
          skip: (newPage - 1) * perPage,
        },
      });
    }
  };
  const customSort = (rows, field, direction) => {
    const handleField = row => {
      if (row[field]) {
        return row[field].toLowerCase()
      }
      return row[field]
    }
    return orderBy(rows, handleField, direction)
  }
  const getWorkerStatus = (status) => {
    const statusMap = {
      0: 'Not Started',
      1: 'Pp Assigned',
      2: 'Pp In Progress',
      3: 'Pp Completed',
      4: 'Billing Assigned',
      5: 'Billing In Progress',
      6: 'Billing Completed',
      7: 'Rider Assign Manual',
      8: "Rider Assigned",
      9: 'Rider Out For Delivery',
      10: 'Rider Delivered'
    };
    return statusMap[status] || 'N/A';
  };

  function CheckOrderStatus(orderStatusCode) {

    if (orderStatusCode === 0) {
      return "Initiated"
    }
    else if (orderStatusCode === 1) {
      return "Confirmed"
    }
    else if (orderStatusCode === 2) {
      return "Packing"
    }
    else if (orderStatusCode === 3) {
      return "Order billing"
    }
    else if (orderStatusCode === 4) {
      return "Ready for delivery"
    }
    else if (orderStatusCode === 5) {
      return "Rider Assigned"
    }
    else if (orderStatusCode === 6) {
      return "Out for delivery"
    }
    else if (orderStatusCode === 7) {
      return "Delivered"
    }
    else if (orderStatusCode === 8) {
      return "Cancelled"
    }
    else if (orderStatusCode === 9) {
      return "Out of stock"
    }
    else if (orderStatusCode === 10) {
      return "Invalid delivery address"
    }
    else if (orderStatusCode === 12) {
      return "No Items Cart"
    }
    else {
      return "Failed"
    }

  }
  function getOrderStatusColor(orderStatusCode) {
    switch (orderStatusCode) {
      case 0: return "grey"; // Initiated
      case 1: return "blue"; // Confirmed
      case 2: return "orange"; // Packing
      case 3: return "purple"; // Order billing
      case 4: return "darkblue"; // Ready for delivery
      case 5: return "teal"; // Rider Assigned
      case 6: return "green"; // Out for delivery
      case 7: return "lightgreen"; // Delivered
      case 8: return "red"; // Cancelled
      case 9: return "darkred"; // Out of stock
      case 10: return "brown"; // Invalid delivery address
      case 12: return "yellow"; // No Items Cart
      default: return "black"; // Failed
    }
  }

  const getOrderWorkerEmail = (orderState) => {
    switch (orderState.workerStatus) {
      case 1:
        return orderState.ppWorkerAssignedEmail ? orderState.ppWorkerAssignedEmail : "NA"
      case 2:
        return orderState.ppWorkerAssignedEmail ? orderState.ppWorkerAssignedEmail : "NA"
      case 3:
        return orderState.ppWorkerAssignedEmail ? orderState.ppWorkerAssignedEmail : "NA"
      case 4:
        return orderState.billingWorkerAssignedEmail ? orderState.billingWorkerAssignedEmail : "NA";
      case 5:
        return orderState.billingWorkerAssignedEmail ? orderState.billingWorkerAssignedEmail : "NA";
      case 6:
        return orderState.billingWorkerAssignedEmail ? orderState.billingWorkerAssignedEmail : "NA";
      case 7:
        return orderState.riderAssignedEmail ? orderState.riderAssignedEmail : "NA";
      case 8:
        return orderState.riderAssignedEmail ? orderState.riderAssignedEmail : "NA";
      case 9:
        return orderState.riderAssignedEmail ? orderState.riderAssignedEmail : "NA";
      case 10:
        return orderState.riderAssignedEmail ? orderState.riderAssignedEmail : "NA";
      default:
        return 'No Worker Assigned';
    }
  };

  const columns = [
    {
      name: 'Order ID',
      selector: '_id', // Assuming "_id" is the field containing the order ID
      cell: (row) => <>{row._id.slice(-5)}</>, // Display only the last 5 characters of the Order ID
      style: { cursor: 'pointer' },
    },
    {
      name: 'Name',
      selector: 'customerName',
      cell: (row) => <>{row.customerName || 'NA'}</>,
      style: { cursor: 'pointer', minWidth: "110px" },
    },
    {
      name: 'Order Date',
      selector: 'orderDate',
      cell: (row) => <>{formatOrderDate(row.orderDate)}</>,
      style: { cursor: 'pointer' },
    },
    {
      name: 'Delivery Date',
      selector: 'deliveryDate',
      cell: (row) => {
        // Extract the date part from the delivery date string
        const datePart = row.deliveryDate.split(',')[0];
        // Parse the date part and format it
        const [day, month, year] = datePart.split(' ');
        const formattedDate = new Date(`${month} ${day.replace(/\D/g, '')}, ${year}`).toLocaleDateString();
        return <>{formattedDate}</>;
      },
      style: { cursor: 'pointer', minWidth: "110px" },
    },

    {
      name: 'Amount',
      selector: 'orderAmount',
      style: { cursor: 'pointer' },
    },
    {
      name: 'Order Status',
      selector: 'orderStatus',
      cell: (row) => (
        <Typography style={{
          color: getOrderStatusColor(row.orderStatus), fontWeight: 600, fontFamily: ['Euclid Circular A', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'].join(', '),
          fontOpticalSizing: "auto", fontSize: '13px',
        }}>
          {CheckOrderStatus(row.orderStatus)}
        </Typography>
      ),
      style: { cursor: 'pointer', minWidth: "150px" },
    },
  
    {
      name: 'Worker Status',
      selector: 'workerEmail',
      cell: (row) => (
        <>
          {row.orderState && row.orderState.workerStatus !== undefined
            ? getWorkerStatus(row.orderState.workerStatus)
            : 'NA'}
        </>
      ),
      style: { cursor: 'pointer', minWidth: "150px" },
    },
    
    {
      name: 'Worker Email',
      selector: 'workerEmail',
      cell: (row) => {
        const workerEmail = row.orderState ? getOrderWorkerEmail(row.orderState) : 'NA';
        const handleClick = () => {
          localStorage.setItem('workerEmail', workerEmail);
        };
        return (
          <span onClick={handleClick} style={{ cursor: 'pointer' }}>
            {workerEmail}
          </span>
        );
      },
      style: { cursor: 'pointer', minWidth: "250px" },
    },
   {
      name: 'Locked Rider Email', // Column header
      selector: 'orderState.lockedRiderEmail', // **Updated selector path**
      cell: (row) => <>{row.orderState && row.orderState.lockedRiderEmail || 'NA'}</>,
      style: { cursor: 'pointer', minWidth: '200px', textAlign: 'left' },
    },

  {
  name: "Delivery Address",
  sortable: false,
  cell: function cell(row) {
  //console.log("ROW DATA:", row);  // Log the row data
  return row.deliveryAddress && row.deliveryAddress.deliveryAddress
    ? row.deliveryAddress.deliveryAddress
    : "NA";
},
  style: {
    cursor: 'pointer',
    minWidth: "300px",
    textAlign: 'left'
  }
},

    ...(userType !== 2
      ? [
        {
          name: 'Local Store',
          selector: 'localStore',
          cell: row => <>{row.localStore.join(', ')}</>,
          style: { cursor: 'pointer' },
        },
      ]
      : []),
    {
      name: t('Action'),
      cell: (row) => <>{actionButtons(row)}</>,
    },

  ];

 

 

  const filterData = (filterInput) => {
    setDefaultValue(filterInput);
    FilterPaload = {
      filterInput: cleanPayload(filterInput),
      limit: perPage, skip: (page - 1) * perPage,
    };
    console.log("filterData called with:", FilterPaload); // LOG 1
    refetchfilterData({
      variables: FilterPaload,
    });
    setbadgeContent(true);
  };

  const actionButtons = row => {
    return (
      <>
        <Button
          size="20px"
          variant="contained"
          sx={{
            fontWeight: 'bold',
            backgroundColor: theme.palette.warning.dark,
            color: theme.palette.common.white,
            padding: 0,
            height: '15px',
            fontSize: '7px',
            '&:hover': {
              border: '2px solid #637BFE',
              color: theme.palette.warning.dark,
              backgroundColor: "white",
            },
          }}
          onClick={e => {
            e.preventDefault();
            localStorage.setItem('orderDetails', JSON.stringify(row));
             // Save pagination and scroll position
    localStorage.setItem(LAST_ORDER_LIST_PAGE, page.toString());
    
    localStorage.setItem(IS_BACK_FROM_ORDER_DETAILS, 'true');
    localStorage.setItem(LAST_ORDER_LIST_PER_PAGE, perPage.toString());
    localStorage.setItem(LAST_SELECTED_ORDER_ID, row._id);
    localStorage.setItem('lastOrderSearchField', searchField);

    if (tableRef.current) {
      localStorage.setItem(
        LAST_ORDER_LIST_SCROLL_POS,
        tableRef.current.parentElement.parentElement.scrollTop.toString()
      );
    }
    setSelectedOrderId(row._id);

    // Save search query if present
    // Save search query and field if present
if (searchQuery) {
  localStorage.setItem('isOrderSearchActive', 'true');
  localStorage.setItem('lastOrderSearchQuery', searchQuery);
  localStorage.setItem('lastOrderSearchField', searchField); // <-- ADD THIS
} else {
  localStorage.setItem('isOrderSearchActive', 'false');
  localStorage.removeItem('lastOrderSearchQuery');
  localStorage.removeItem('lastOrderSearchField'); // <-- ADD THIS
}


    // Save filters if applied
    if (badgeContent) {
      localStorage.setItem('lastOrderFilterPayload', JSON.stringify(FilterPaload));
      localStorage.setItem('lastOrderFilterDefaults', JSON.stringify(DefaultValue));
      localStorage.setItem('isOrderFilterApplied', 'true');
    } else {
      localStorage.removeItem('lastOrderFilterPayload');
      localStorage.removeItem('lastOrderFilterDefaults');
      localStorage.setItem('isOrderFilterApplied', 'false');
    }
            const userType = JSON.parse(localStorage.getItem('user-native')).userType;
            let routePath = '';
            switch (userType) {
              case 0:
                routePath = '/super_admin/OrderDetails';
                break;
              case 1:
                routePath = '/cs_admin/OrderDetails';
                break;
              case 2:
                routePath = '/local_admin/OrderDetails';
                break;
              default:
                routePath = '/super_admin/OrderDetails'; // Default to super admin if userType is not defined
                break;
            }
            props.history.push({
              pathname: routePath,
              state: { id: row._id },
            });
          }}
        >
          {t('ViewDetails')}
        </Button>
      </>
    );
  };
  const [OpenFilter, setOpenFilter] = useState(false);
  const handleOpenFilter = () => {
    setOpenFilter(true);
  };
  const CloseFilter = () => {
    setOpenFilter(false);
  };
  const handleResetFilters = () => {
    setFilterPaload({});
    setDefaultValue({});
    setPage(1);
    setCurrentPage(1);
    setSearchQuery(''); // Reset search query as well
    setReload(!reload);
    setbadgeContent(false);
  };

  const onChangeSearch = (e) => {
    setSearchQuery(e.target.value);
    setPage(1); // Reset page on search
  };

  const onClickRefetch = () => {
    setSearchQuery('');
    setPage(1);
    setCurrentPage(1);
    refetch()
    setbadgeContent(false);
    setReload(!reload);
    setFilterPaload({});
    setDefaultValue({});
  };
  const conditionalRowStyles = [
  {
    when: row => row._id === selectedOrderId,
    style: {
      backgroundColor: theme.palette.action.selected, // highlight row
    },
  },
];

  return (
      <>
       {OpenFilter && (
        <AllOrderFilter
         open={OpenFilter}
         close={CloseFilter}
         filterData={filterData}
         DefaultValue={DefaultValue}
         handleResetFilters={handleResetFilters}
        />
       )}
       <Header />
       <Container className={globalClasses.flex} fluid>
       <Box sx={{ display: 'flex', alignItems: 'center', gap: 0, marginBottom: 0,marginTop: 1, marginLeft: 'auto' }}>

        <FormControl>
        <InputLabel
          id="search-by-label"
          shrink={!!searchField} //  this is the fix
          sx={{ textAlign: 'center' }}
        >
          {t('Search By')}
        </InputLabel>
        <Select
        labelId="search-by-label"
        label="Display Type"
        value={searchField}
        onChange={handleSearchFieldChange}
        sx={{
          minWidth: 160,
          height: 40,
          
        
          borderRadius: '4px',

          color: 'black !important', // Attempt to set text color directly on Select
          '& .MuiMenuItem-root': {
          color: 'black !important', // Target MenuItem root
          },
          '& .MuiListItemText-primary': {
          color: 'black !important', // Target primary text in MenuItem
          },
        }}>
        <MenuItem value="name" sx={{ color: 'black !important' }}>{t('Name')}</MenuItem>
        <MenuItem value="orderId" sx={{ color: 'black !important' }}>{t('Order ID')}</MenuItem>
        <MenuItem value="phone" sx={{ color: 'black !important' }}>{t('Phone')}</MenuItem>
        </Select>
        </FormControl>
        </Box>
        {loadingQuery ? (
         <CustomLoader />
        ) : (
         <Box sx={{ width: '100%', overflowX: 'auto' }}>
          <DataTable
           key={perPage} 
          ref={tableRef} // Attach ref to DataTable
           customStyles={customStyles}
           subHeaderComponent={
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0, marginBottom: 0, width: '100%' }}>
              <SearchBar
               value={searchQuery}
               onChange={(e) => setSearchQuery(e.target.value)}
               placeholder={t(searchField ? `Search by ${t(searchField === 'orderId' ? 'Order ID' : searchField === 'phone' ? 'Phone' : 'Name')}` : 'Search by')}
               onSearch={handleSearch}
               onClear={onClickRefetch}
               onClick={() => onClickRefetch(refetch)}
               style={{ flexGrow: 1, maxWidth: 200, height: 40 }} // Adjusted maxWidth and added height
              />
             
             <Box style={{ marginTop: -40 }}>
              {badgeContent ? (
               <Badge
                badgeContent={""}
                color="success"
                variant="dot"
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
               >
                <Button onClick={handleOpenFilter}>
                 <TuneIcon />
                </Button>
               </Badge>
              ) : (
               <Button onClick={handleOpenFilter}>
                <TuneIcon />
               </Button>
              )}
             </Box>
            </Box>
           }
           
           subHeader={true}
           title={<TableHeader title={t("All Orders")} />}
           columns={columns}
           data={tableData || []}
           progressPending={loadingQuery}
           progressComponent={<CustomLoader />}
           paginationPerPage={perPage}
           paginationDefaultPage={currentPage}
           pagination
           paginationServer
           paginationTotalRows={totalRows}
           onChangeRowsPerPage={handlePerRowChange}
           onChangePage={handlePageChange}
           sortFunction={customSort}
           conditionalRowStyles={conditionalRowStyles} 
          />
         </Box>
        )}
       </Container>
      </>
     );
    };
    export default withTranslation()(Restaurants);
